// extracted by mini-css-extract-plugin
module.exports = {"UserDetails":"UserDetails_UserDetails__zf1GS","main":"UserDetails_main__2Mmgy","footer":"UserDetails_footer__1eCq-","logOutBtn":"UserDetails_logOutBtn__1-_X1"};